<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{ $t('messages.log_in_to_30teb') }}</h4>
                  <p>{{ $t('messages.welcome_to_30teb') }}</p>
                </div>

                <vs-tabs :value="locale">
                  <vs-tab @click="updateLocale('en')" :label="$t('general.english')">
                    <login-jwt></login-jwt>
                  </vs-tab>
                  <vs-tab @click="updateLocale('fa')" :label="$t('general.persian')">
                    <login-jwt></login-jwt>
                  </vs-tab>
                  <vs-tab @click="updateLocale('ar')" :label="$t('general.arabic')">
                    <login-jwt></login-jwt>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import LoginJwt from './LoginJWT.vue'

export default {
  components: {
    LoginJwt
  },
  computed: {
    locale() {
      if (this.$i18n.locale === 'en') return 0
      else if (this.$i18n.locale === 'fa') return 1
      else if (this.$i18n.locale === 'ar') return 2
      return null
    }
  },
  methods: {
    updateLocale(locale) {
      if (locale === 'en') this.$vs.rtl = false
      else if (locale === 'fa') this.$vs.rtl = true
      else if (locale === 'ar') this.$vs.rtl = true
      localStorage.setItem('locale', locale)
      this.$i18n.locale = locale
    }
  },
  mounted() {
    if (this.$route.query.to) sessionStorage.setItem('redirectTo', this.$route.query.to)

    if (this.$store.state.auth.isUserLoggedIn()) {
      this.$vs.notify({
        title: this.$t('messages.login_attempt'),
        text: this.$t('messages.already_logged_in'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      if (this.$route.query.to) window.location = this.$route.query.to
      this.$router.push('/').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
